import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  nNumber,
  nString,
  uNumber,
} from '@hidat/huijs-common';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { ResourceConfig } from '@hidat/huijs-resource';
import { splixerSystemFields } from './splixer-fields.const';
import { ZonedDateTime } from '@js-joda/core';
import { MediaContentTypes } from './splixer-types';

export const RawPlayConfig = new ResourceConfig(
  'RawPlay',
  'raw_plays',
  false,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    new FieldConfig('rawShowId', FieldDataTypes.INTEGER),
    new FieldConfig('remoteId', FieldDataTypes.INTEGER),
    new FieldConfig('remoteCode'),
    new FieldConfig('broadcastedAt', FieldDataTypes.DATETIME),
    new FieldConfig('duration', FieldDataTypes.NUMBER),
    new FieldConfig('contentType'),
    new FieldConfig('play', FieldDataTypes.HASH).setEditable(false),
  ])
  .setSorts({
    broadcastedat: 'broadcastedAt',
  })
  .setDefaultSort('broadcastedat');

export interface RawPlayInterface extends SplixerResourceInterface<number> {
  stationId: uNumber;
  channelId: uNumber;
  contentType: MediaContentTypes | undefined;
  broadcastedAt: ZonedDateTime | undefined;
  duration: number | undefined;
  play: AnyHash | undefined;
  rawShowId: nNumber;
  remoteId: nNumber;
  remoteCode: nString;
}
